import PlatformLoader from '@breeze-platform-ui/loader';
import type { LoaderProps } from '@breeze-platform-ui/loader';

export const Loader = (props: LoaderProps) => {
  return (
    <PlatformLoader
      color="var(--tds-color-primary)"
      size="m"
      centered
      {...props}
    />
  );
};
